//------------ IMPORTAÇÕES ------------//
import { useEffect, useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Loading } from "../../shared/components";
import { LoadingContext } from "../../shared/context/LoadingContext";
import { loadGroupsProductsService } from "./services";
import { Main } from "./components";
import { TrafegoContext } from "./context/TrafegoContext";



//------------ EXPORTAÇÃO DA PÁGINA RELATÓRIO GRUPO ------------//
export default function RelatorioGrupo() {



  //------------ CRIAÇÃO DE HOOKS ------------//
  const { groups, setGroups } = useContext(TrafegoContext); // Estado que armazena a lista dos grupos existentes
  const { startDateFilter, setStartDateFilter } = useContext(TrafegoContext);
  const { endDateFilter, setEndDateFilter } = useContext(TrafegoContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext); // Estado que armazena se a tela de carregamento está aparecendo ou não (inicia aparecendo)



  //------------ USE EFFECT DE INICIALIZAÇÃO ------------//
  useEffect(() => {
    handleLoadGroupsProducts();
    handleLoadDates();
  }, []);



  //------------ FUNÇÃO ASSÍNCRONA HANDLE LOAD GROUPS PRODUCTS ------------//
  const handleLoadGroupsProducts = async () => {
    setIsLoading(true);
    const response = await loadGroupsProductsService();
    if (response) {
      setGroups(response.data.map(g => ({ id: g.id, nome: g.nome })));
    }
    setIsLoading(false);
  };



  //------------ FUNÇÃO HANDLE LOAD DATES ------------//
  function handleLoadDates() {
    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth(), 1);
    const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const pad = n => String(n).padStart(2, "0");
    const fmt = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    setStartDateFilter(fmt(start));
    setEndDateFilter(fmt(end));
  }



  //------------ RETORNO CONDICIONAL DA PÁGINA RELATÓRIO GRUPO ------------//
  return (
    <>
      {isLoading || !groups
        ? <Loading />
        : <Main />
      }
    </>
  )
}